export const LOCALE_PREFIX = 'components.Dialog.components.UserProfile.components.Menu.components.Item'
